import {
    type Dialog,
    type GetProps,
    SimpleModal,
    type SimpleModalProps,
} from 'smoothie';

// Grove-specific wrapper for SimpleModal that uses responsive width based on window size
// instead of the fixed CONTENT_MAX_WIDTH from Smoothie.
// This allows modals to take up more space on larger screens for better use of real estate.
export const GroveSimpleModal = ({
    children,
    ...modalProps
}: SimpleModalProps) => {
    const contentProps: GetProps<typeof Dialog.Content> = {
        width: 'auto',
    };

    return (
        <SimpleModal dialogProps={contentProps} {...modalProps}>
            {children}
        </SimpleModal>
    );
};
